import { Pipe, PipeTransform, Inject } from '@angular/core';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/en';
import 'dayjs/locale/vi';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

dayjs.extend(localizedFormat);

@Pipe({ name: 'amDateFormat' })
export class DateFormatPipe implements PipeTransform {
  constructor(
    @Inject(I18NEXT_SERVICE) private i18n: ITranslationService
  ) {
  }
  transform(value: dayjs.ConfigType, ...args: any[]): string {
    if (!value) {
      return '';
    }
    return dayjs(value).locale(this.i18n.language).format(args[0]);
  }
}
